import type { Article } from "@/types/content";
import ArticleCard from "@/components/base/ArticleCard";

interface ArticleRelatedProps {
  articles: Article[];
}

export default function ArticleRelated({ articles }: ArticleRelatedProps) {
  if (articles.length === 0) return null;

  return (
    <section className="max-w-portal mx-auto px-4 md:px-6 pt-12 md:pt-16">
      <div className="flex items-center gap-3 mb-6">
        <span className="w-6 h-px bg-accent-500" aria-hidden="true" />
        <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
          相关推荐
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {articles.map((item) => (
          <ArticleCard key={item.id} article={item} />
        ))}
      </div>
    </section>
  );
}